import React from 'react';
import { MapPin, Phone, Mail, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
const credit = 'text-slate-500 no-underline transition-colors hover:text-slate-300';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 pt-16 pb-8 px-4 border-t border-slate-800" data-id="element-68" data-mp="32p5qssbzpiul">
      <div className="max-w-7xl mx-auto" data-id="element-69" data-mp="36q953aee36tp">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-70" data-mp="36n3grxdl48z1">
          {/* Company Info */}
          <div className="space-y-4" data-id="element-71" data-mp="38h7nghhhuo4">
            <div className="mb-6" data-id="element-72" data-mp="37fpks21w7ww">
              <img src="https://cdn.magicpatterns.com/uploads/mLJdqn1YBuqHdE7DWNbtyp/pasted-image.webp" alt="A-Flow Seamless Rain Gutters" className="h-12 w-auto bg-white p-2 rounded-lg" data-id="element-73" data-mp="36d1st00yll7" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-74" data-mp="29xm06nd2d2ik">
              Providing top-quality seamless aluminum and copper rain gutters
              for residential and commercial properties in Southern California.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-800 rounded-md text-sm font-medium text-slate-200 border border-slate-700" data-id="element-75" data-mp="3gah13thslj5u">
              <ShieldCheck className="w-4 h-4 text-[#b87333]" data-id="element-76" data-mp="3v9azhcaljycb" />
              Licensed & Insured
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-77" data-mp="82icpt2wkaeu">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-78" data-mp="81yvyfozns2e">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-79" data-mp="33nmw76ipll8">
              {[{
              name: 'Home',
              href: '/'
            }, {
              name: 'About Us',
              href: '/about'
            }, {
              name: 'Services',
              href: '/services'
            }, {
              name: 'Appointment Request',
              href: '/appointment'
            }, {
              name: 'Contact Us',
              href: '/contact'
            }].map(link => <li key={link.name} data-id="element-80" data-mp="13tkd00sme5ce">
                  <Link to={link.href} className="text-slate-400 hover:text-[#b87333] transition-colors text-sm flex items-center gap-2" data-id="element-81" data-mp="13sis74lsy4hh">
                    <span className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-82" data-mp="1ckt2elwp69yq" />
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-83" data-mp="1mhpcux65p65x">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-84" data-mp="1mhxmmg6zfvcw">
              Our Services
            </h3>
            <ul className="space-y-3" data-id="element-85" data-mp="3obx11afeistt">
              <li className="text-slate-400 text-sm" data-id="element-86" data-mp="3oczqddx2sn7m">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-87" data-mp="3t9q7m4km9oum">
                  Seamless Rain Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-88" data-mp="25nlqmyt9kwx2">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-89" data-mp="21mtiya01j02w">
                  Copper Gutters
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-90" data-mp="2tehpgfw50sdt">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-91" data-mp="2tbvioih2mgwn">
                  Gutter Guards
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-92" data-mp="2kf4bpb0zdhna">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-93" data-mp="2fdf30218dg2d">
                  Gutter Repair
                </Link>
              </li>
              <li className="text-slate-400 text-sm" data-id="element-94" data-mp="13xqe354f26yx">
                <Link to="/services" className="hover:text-[#b87333] transition-colors" data-id="element-95" data-mp="2rv7o9uxwjtzq">
                  Maintenance & Cleaning
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-96" data-mp="2ntw6ucp6mf2m">
            <h3 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-97" data-mp="2ntcq2zb9pwq6">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-98" data-mp="3bk8dzlcls7s5">
              <li className="flex items-start gap-3 text-sm text-slate-400" data-id="element-99" data-mp="3flbqpyzctnp5">
                <MapPin className="w-5 h-5 text-[#b87333] shrink-0 mt-0.5" data-id="element-100" data-mp="3fj7pjosub2sk" />
                <span data-id="element-101" data-mp="31l10my5vcd51">
                  Orange County, CA
                  <br data-id="element-102" data-mp="36k462jprgldj" />
                  Serving Southern California
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-103" data-mp="1q648hfee17tg">
                <Phone className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-104" data-mp="1v574ybgay5pt" />
                <a href="tel:7146023634" className="hover:text-white transition-colors" data-id="element-105" data-mp="1v3du0jynozc0">
                  (714) 602-3634
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-400" data-id="element-106" data-mp="1ip7cdm0p2vb4">
                <Mail className="w-5 h-5 text-[#b87333] shrink-0" data-id="element-107" data-mp="1wlumkqhnrhyz" />
                <a href="mailto:info@aflowraingutters.com" className="hover:text-white transition-colors" data-id="element-108" data-mp="1rom56s4c3hys">
                  info@aflowraingutters.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500" data-id="element-109" data-mp="1dpcntp4e6ht8">
          <p data-id="element-110" data-mp="l7h2zxtxtoor">
            © {new Date().getFullYear()} A-Flow Seamless Rain Gutters. All
            rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-111" data-mp="g95tjo7k1g72">
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-112" data-mp="g849iu8k9jd7">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-113" data-mp="2l9qfbs4ci3av">
              Terms of Service
            </a>
          </div>
        </div>
        <div className="mt-4 flex flex-col items-center gap-1 text-center text-xs text-slate-500 sm:flex-row sm:justify-center sm:gap-3" data-id="element-114" data-mp="2q1ro342b1bw5">
          <span data-id="element-115" data-mp="2v1cnffldzm9e">
            <a href="https://adroimarketing.com/#/design/websites" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-116" data-mp="1xc16gl1grrva">Website Design</a>,{' '}
            <a href="https://adroimarketing.com/#/marketing/local-seo" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-117" data-mp="22b4emecqqe7h">Marketing</a> by{' '}
            <a href="https://adroimarketing.com/" target="_blank" rel="noopener noreferrer" className={credit} data-id="element-118" data-mp="2bbspx1ar20go">Ad ROI Marketing</a>
          </span>
          <span aria-hidden="true" className="hidden opacity-50 sm:inline" data-id="element-119" data-mp="3ir6wrn6hysow">|</span>
          <span data-id="element-120" data-mp="3mp4r14f4k4z5">
            <a href="https://adroimarketing.com/#/crm" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-121" data-mp="3msshtvt6qda6">Sales Automation CRM</a> by{' '}
            <a href="https://1Dash.Pro" target="_blank" rel="noopener noreferrer" className={credit} data-id="element-122" data-mp="172ts4kkgig6t">1Dash.Pro</a>
          </span>
        </div>
      </div>
    </footer>;
}